<template>

  <AbortStateTemplate
      :headline="abortHeadline"
      :message="abortMessage"
      :teaserCards="teaserCardsData"
  />
</template>

  <script>
  import teaserCardsData from "@/data/teaserData";
  import AbortStateTemplate from "@/components/abortStates/AbortStateTemplate.vue";

  export default {
    name: 'StateAbortBuildingAge',
    components: {
      AbortStateTemplate,
    },
    data() {
      return {
        abortHeadline:
            "Vielen Dank für Ihre Interesse. Leider können wir kein passendes Angebot für das Haus erstellen.",
        abortMessage:
            "Da der Bau des Hauses noch nicht abgeschlossen ist, fehlen zum aktuellen Zeitpunkt noch Informationen. Unser Angebot richtet sich derzeit nur an Bestandsgebäude - Sobald die Arbeiten an Ihrem Haus abgeschlossen sind, freuen wir uns, Sie erneut begrüßen zu dürfen.",
          teaserCardsData
    };
    },
  }
  </script>

